import React from 'react';
import { BrowserRouter } from 'react-router-dom';
import Body from './Body'
import AppHeader from './AppHeader/AppHeader';
import SideNavBar from './SideNavBar/SideNavBar';

const AppLayout = () => {

  return (
    <div>
      <BrowserRouter>
        <AppHeader />
        <SideNavBar />
        <Body />
      </BrowserRouter>
    </div>
  );
};

export default AppLayout
